import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/dom-utils';

import Loading from '../../Icons/Loading';
import IconPlus from '../../Icons/IconPlus';
import Close from '../../Icons/Close';

class Autosuggest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      membersToNotify: this.props.membersToNotify,
      members: this.props.availableMembers,
      addMember: false,
      addMemberValue: '',
      KEY: {
        backspace: 8,
        tab: 9,
        enter: 13,
      },
      error: false,
      inputText: '',
      openDialog: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.availableMembers != prevProps.availableMembers
            && this.props.availableMembers != this.state.members
    ) {
      // eslint-disable-next-line
      this.setState({ members: this.props.availableMembers });
    }
    if (
      this.props.membersToNotify != prevProps.membersToNotify
            && this.props.membersToNotify != this.state.membersToNotify
    ) {
      // eslint-disable-next-line
      this.setState({
        membersToNotify: this.props.membersToNotify,
      });
    }
  }

  handleInputClick(event) {
    const { children } = event.target;
    if (children.length) children[children.length - 1].focus();
  }

  handleOnKeyDown() {
    const keyPressed = event.which;

    if (this.state.error) {
      this.setState({ error: false });
    } else if (
      keyPressed === this.state.KEY.enter
            || (keyPressed === this.state.KEY.tab && event.target.value)
    ) {
      event.preventDefault();
      this.updateMembers(event);
    } else if (keyPressed === this.state.KEY.backspace) {
      const membersToNotify = [...this.state.membersToNotify];

      if (!event.target.value && membersToNotify.length) {
        this.deleteChip(membersToNotify[membersToNotify.length - 1]);
      }
    }
  }

  handleMemberSelect(member) {
    if (member && this.state.membersToNotify.indexOf(member) < 0) {
      const membersToNotify = [...this.state.membersToNotify];

      if (member.trim.length > 0 || member.replace(/\s/g, '').length) {
        membersToNotify.push(member);
        this.setState({ membersToNotify });
        this.props.onChange(membersToNotify);
      }
    }
    this.setState({ inputText: '', addMemberValue: '', addMember: false });
    this.closeDialog();
  }

  handleFilterMembers(event) {
    const { value } = event.target;
    this.setState({ inputText: value });

    if (this.state.members && value != '') {
      const currentMembers = [...this.state.members];

      const filteredMembers = currentMembers.filter(
        (member) => member.toLowerCase().search(value.toLowerCase()) != -1,
      );

      this.setState({
        members: filteredMembers,
        addMember: filteredMembers.length == 0,
        addMemberValue: value,
      });
    } else if (value === '') {
      this.setState({
        members: this.props.availableMembers,
        addMember: false,
        addMemberValue: value,
      });
    }
  }

  openDialog() {
    this.setState({ openDialog: true });
  }

  closeDialog() {
    this.setState({ openDialog: false });
  }

  updateMembers(event) {
    if (
      !this.props.max
            || this.state.membersToNotify.length < this.props.max
    ) {
      const { value } = event.target;
      if (value.trim() != '' || value.replace(/\s/g, '').length) {
        const chip = value.trim();

        if (chip && this.state.membersToNotify.indexOf(chip) < 0) {
          // eslint-disable-next-line
          const membersToNotify = [...this.state.membersToNotify];
          membersToNotify.push(chip);
          this.setState({
            membersToNotify,
            addMemberValue: '',
            addMember: false,
            inputText: '',
          });
          this.props.onChange(membersToNotify);
        }
      } else {
        this.setState({ error: true });
      }
    }
  }

  deleteChip(value) {
    const currentList = [...this.state.membersToNotify];
    if (currentList.includes(value)) {
      const list = currentList.filter((x) => x !== value);
      this.setState({ membersToNotify: list });
      this.props.onChange(list);
    }
  }

  renderSuggestions() {
    const { members } = this.state;
    const suggestedMembers = members.length > 20 ? members.slice(0, 20) : members;
    const { mode } = this.props;
    const valueBaseClass = 'auto-suggest';

    const suggestionClass = classNames({
      [`${valueBaseClass}--${mode}__suggestion`]: mode,
    });
    return suggestedMembers.map((member, index) => (
      // eslint-disable-next-line
      <div
      // eslint-disable-next-line
        role="option"
        className={suggestionClass}
        id={`suggestion-${index}`}
        // eslint-disable-next-line
        key={index}
        onMouseDown={this.handleMemberSelect.bind(this, member)}
      >
        {member}
      </div>
    ));
  }

  render() {
    const { mode } = this.props;
    const valueBaseClass = 'chip-value';
    const deleteBaseClass = 'chip-delete-button';
    const membersBaseClass = 'members';
    const suggestBaseClass = 'auto-suggest';

    const chipValueClass = classNames(valueBaseClass, {
      [`${valueBaseClass}--${mode}`]: mode,
    });

    const chipDeleteClass = classNames(deleteBaseClass, {
      [`${deleteBaseClass}--${mode}`]: mode,
    });

    let membersClass = classNames(membersBaseClass, {
      [`${membersBaseClass}--${mode}`]: mode,
    });

    if (this.state.openDialog && mode == 'darkmode') {
      membersClass = `${membersClass} members--darkmode-open`;
    }

    const membersWrapperClass = classNames(`${membersBaseClass}__wrapper`, {
      [`${membersBaseClass}__wrapper--${mode}`]: mode,
    });

    let suggestClass = classNames(suggestBaseClass, {
      [`${suggestBaseClass}--${mode}`]: mode,
    });

    if (this.state.openDialog) {
      suggestClass = `${suggestClass} auto-suggest--open`;
    }

    const addClass = classNames({
      [`${suggestBaseClass}--${mode}__add`]: mode,
    });

    const list = this.state.membersToNotify.map((chip, index) => (
      // eslint-disable-next-line
      <span className="chip" key={index}>
        <span className={chipValueClass}>{chip}</span>
        <button
          type="button"
          className={chipDeleteClass}
          aria-label="delete button"
          onClick={this.deleteChip.bind(this, chip)}
        >
          <Close />
        </button>
      </span>
    ));
    const placeholder = !this.props.max || list.length < this.props.max
      ? this.props.placeholder
      : '';

    let suggestDiv = '';
    if (
      (this.state.members && this.state.members.length > 0)
            || this.state.addMember
    ) {
      let addMemberItem = '';
      if (this.state.addMember) {
        addMemberItem = (
          // eslint-disable-next-line
          <div
          // eslint-disable-next-line
            role="option"
            id="add-member"
            key="add-member"
            className={addClass}
            onMouseDown={this.handleMemberSelect.bind(
              this,
              this.state.addMemberValue,
            )}
          >
            <IconPlus />
            <span>{this.state.addMemberValue}</span>
          </div>
        );
      }
      suggestDiv = (
        <div id={this.props.id} className={suggestClass}>
          {this.renderSuggestions()}
          {addMemberItem}
        </div>
      );
    }
    return (
      <div className={membersWrapperClass}>
        {/* eslint-disable-next-line */}
        <label>{this.props.label}</label>
        <p className="members__description">{this.props.description}</p>
        {/* eslint-disable-next-line */}
        <div
          data-testid="members-element"
          className={membersClass}
          onClick={this.handleInputClick.bind(this)}
        >
          {list}
          <input
            onFocus={this.openDialog.bind(this)}
            onBlur={this.closeDialog.bind(this)}
            type="text"
            className="members__input"
            placeholder={placeholder}
            onChange={this.handleFilterMembers.bind(this)}
            onKeyDown={this.handleOnKeyDown.bind(this)}
            value={this.state.inputText}
          />
        </div>
        <footer>{this.props.footerText}</footer>

        {suggestDiv}
        {this.props.isLoading && (
        <Loading className="auto-suggest__loader" />
        )}
      </div>
    );
  }
}

Autosuggest.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  footerText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  availableMembers: PropTypes.array.isRequired,
  membersToNotify: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  max: PropTypes.number.isRequired,
  mode: PropTypes.oneOf(['darkmode', 'lightmode']).isRequired,
};

export default Autosuggest;
